import { MatchStatisticsDetail, IMatchStatisticsDetail } from "@sky-it-livedata/livedata-sports-design-system";
import { useSubscription } from "../../hooks/useSubscription";
import { graphql } from "appsync";
import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { LmpMatchStatisticsQuery, LmpMatchStatisticsSubscription } from "./types";

import transformQuery from "./transformers/query";
import transformSubscription from "./transformers/subscription";


export const setCustomAttributes = ({
  variables,
}: WidgetContext<LmpMatchStatisticsQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

const subscriptionDocument = graphql('subscription LmpStatisticsSubscription($matchId: ID!) {\n  onUpdateLmpStatisticsByMatchId(matchId: $matchId) {\n    matchId\n    status\n    matchStatisticsList {\n      id\n      value {\n        away\n        home\n      }\n    }\n  }\n}');

export const getServerProps = ({
  props
}: WidgetContext<LmpMatchStatisticsQuery>): IMatchStatisticsDetail => {
  return transformQuery(props);
}

const LmpMatchStatisticsWidget = ({
  props,
   variables,
  ...rest
}: WidgetContext<IMatchStatisticsDetail>) => {
  log({ props, variables, ...rest });

  const updatedProps = useSubscription<
    IMatchStatisticsDetail,
    LmpMatchStatisticsSubscription,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables,
    transform: transformSubscription,
    mergeData: true,
  }) as IMatchStatisticsDetail;

  return (
      <MatchStatisticsDetail {...updatedProps} />
  );
}

export default LmpMatchStatisticsWidget;